/* eslint-disable max-len */
const ms = {
  seo: {
    // eslint-disable-next-line max-len
    keywords: 'BiliBili,anime percuma,anime,Anime Teratas,BL,GL,wetv,iqiyi,crunchyroll,Demon Slayer: Kimetsu no Yaiba,Attack on Titan,That Time I Got Reincarnated as a Slime (musim ke-2),Fly Me to the Bulan,Mushoku Tensei: Isekai Ittara Honki Dasu,Berkat Pegawai Syurga,cosplay,SubThai',
  },
  common: {
    more: 'Lagi',
    confirm: 'Sahkan',
    cancel: 'Batal',
    home: 'Home',
    clickToMove: 'Klik untuk leret'
  },
  follow: {
    follow: 'Mengikuti',
    following: 'Mengikuti',
  },
  roomInfo: {
    share: 'Kongsikan',
    copySucceed: 'Pautan disalin berjaya',
    copyFailed: 'Pautan disalin gagal',
    liveClosed: 'Live belum dimulakan',
    viewer: '{count} penonton',
  },
  roomVideo: {
    controlBar: {
      play: 'Mainkan',
      pause: 'Jeda',
      refresh: 'Segarkan',
      refreshSucceed: 'Segarkan berjaya',
      refreshFailed: 'Segarkan gagal',
      refreshing: 'Sedang segarkan',
      fullscreen: 'Mod skrin penuh',
      exitFullscreen: 'Keluar dari skrin penuh',
      switchQning: 'Resolusi sedang ditukar ke',
      switchQnFailed: 'Penukaran resolusi gagal, sila cuba lagi',
      switchQnSucceed: 'Resolusi telah ditukar ke',
    },
  },
  comment: {
    title: 'Danmaku',
    sender_input_placeholder: 'Hantar Danmaku~',
    sended_send: 'Hantar',
    new_messages: 'Kemas kini {count} Danmaku',
    login_before_send: 'Log masuk untuk menyertai karnival Danmaku',
    // eslint-disable-next-line max-len
    default_welcome: 'Selamat datang ke studio penstriman langsung! Kami menggalakkan kandungan yang inovatif dan pelbagai. Pada masa yang sama, kami akan mengambil langkah yang perlu untuk mencegah dan menghentikan sebarang kandungan yang melanggar undang-undang dan peraturan, keperluan peraturan tempatan atau kod etika, atau melanggar hak dan kepentingan sah orang lain, atau yang boleh menjejaskan keselamatan dan kesihatan masyarakat daripada merebak dalam masyarakat. Selain itu, pelanggaran tersebut boleh dilaporkan kepada pihak berkuasa kawal selia mengikut undang-undang dan peraturan yang berkenaan'
  },
  rank: {
    title: 'Papan pengguna',
    login: 'Log masuk',
    viewRank: ' Anda boleh menyemak ranking anda',
    toContribute: 'Hadiahkan Star untuk menduduki papan teratas',
    myScore: 'Nilai sumbangan',
    noData: 'Mari menduduki papan teratas untuk menyokong hos!',
  },
  gift: {
    all: 'Semua Hadiah',
    topUp: 'Tambah nilai',
    top: 'Hangat',
    starDesc: 'Pengguna boleh mendapatkan Star dengan membeli item yang ditukarkan dengan Star boleh jadikan hos memperolehi pendapatan.',
  },
  introduction: {
    title: 'Pengenalan Live',
  },
  balance: {
    insufficientTitle: 'Baki tidak mencukupi',
    insufficientContent: 'Baki Stars tidak mencukupi, sila tambah nilai',
    buy: 'Tambah nilai',
  },
  payment: {
    title: 'Tambah nilai Stars',
    balance: 'Stars Saya',
    next: 'Tambah nilai sekarang',
    agree: 'Tambah nilai akan bersetuju dengan ',
    agreement: 'Perjanjian Tambah Nilai Stars',
    repay: 'Bayar semula',
    getPaid: 'Saya sudah beli',
    orderTitle: 'Sila selesaikan pembayaran pada halaman yang baru',
    exchangeRateDesc: 'Harga pembelian Stars akan berubah dengan turun naik kadar pertukaran dan saluran pembayaran',
    methodTitle: 'Pilih cara pembayaran',
    // eslint-disable-next-line max-len
    orderDesc: 'Jangan tutup halaman ini sebelum pembayaran selesai. Selepas anda menyelesaikan pembayaran, ketuk salah satu daripada butang berikut mengikuti kebenaran anda.',
    toast_success: 'Berjaya tambah nilai',
    toast_fail: 'Gagal tambah nilai',
    toast_notPay: 'Gagal tambah nilai',
    toast_cancel: 'Tambah nilai dibatalkan',
    toast_timeout: 'Tambah nilai tamat masa',
  },

  home: {
    live: 'LIVE',
    liveNow: 'Sedang Live',
    refresh: 'Muat semula',
    refreshFailed: 'Muat semula gagal, sila cuba lagi',
    loadMore: 'Memuatkan lagi...',
    noMore: 'Tiada lagi kandungan',
    clickToLive: 'Klik untuk hidup'
  },

  userCard: {
    followers: '{count} Pengikut',
    videos: '{count} Video',
    promote: 'Lantikkannya sebagai admin',
    demote: 'Pecat admin ini',
    mute: 'Menyekat komen pengguna ini',
    unmute: 'Nyahsekat pengguna ini',
  },
  modals: {
    muteConfirm: 'Pengguna tidak dapat hantar Danmaku selepas disekat komen, adakah anda pasti mahu menyekat komen {username}?',
    muteSuccess: 'Pengguna tersebut telah disekat komen',
    unmuteConfirm: 'Adakah anda pasti mahu membatalkan sekatan komen ke atas {username}?',
    unmuteSuccess: 'Berjaya menyahsekat',
    promoteConfirm: 'Pengguna {username} akan dilantik sebagai admin bilik live anda, adakah anda ingin mengesahkan pelantikan ini?',
    promoteSuccess: 'Hos telah melantik {username} sebagai admin',
    demoteConfirm: 'Pengguna {username} tidak lagi menjadi admin bilik live anda, adakah anda ingin mengesahkan pemecatan ini?',
    demoteSuccess: 'Berjaya memecat',
  },
  chargeStrip: {
    tabProgress: 'Total Chargingi',
    consumeStar: 'Habiskan Star atau selesaikan tugasan untuk dapatkan mata tenaga dan sertai Cabutan Bertuah Bar Pengecasan Tenaga',
    consumeReward: 'Untuk setiap 1 Star yang dihabiskan dalam bilik live ini, anda boleh tambah 1 mata tenaga untuk bilik live ini dan Bar Tenaga Seluruh BiliBili.',
    followRoom: 'Mengikuti bilik live',
    followRoomAward: 'Tambah 3 mata tenaga untuk bilik live yang anda ikuti dan Bar Pengecasan Tenaga Seluruh BiliBili.',
    sendDanmaku: 'Hari ini hantar 1 Danmaku dalam bilik live',
    sendDanmakuAward: 'Tambah 1 mata tenaga untuk bilik live yang anda hantar Danmaku dan Bar Pengecasan Tenaga Seluruh BiliBili.',
    watchLive10M: 'Tonton selama 10 minit dalam satu bilik live',
    watchLive10MAward: 'Tambah 1 mata tenaga untuk bilik live yang anda tonton dan Bar Pengecasan Tenaga Seluruh BiliBili.',
    watchLive30M: 'Tonton selama 30 minit dalam satu bilik live',
    watchLive30MAward: 'Tambah 3 mata tenaga untuk bilik live yang anda tonton dan Bar Pengecasan Tenaga Seluruh BiliBili.',
    watchLive120M: 'Tonton selama 120 minit dalam satu bilik live',
    watchLive120MAward: 'Tambah 15 mata tenaga untuk bilik live yang anda tonton dan Bar Pengecasan Tenaga Seluruh BiliBili.',
    watchLive: 'Tonton selama 10/30/120 minit dalam satu bilik live',
    watchLiveAward: 'Tambah 1/3/15 mata tenaga untuk bilik live yang anda tonton dan Bar Pengecasan Tenaga Seluruh BiliBili.',

    tabTask: 'Charging Tasks',
    uAddRoomEnergy: 'Jumlah mata pengecasan tenaga semasa anda untuk bilik live ialah:',
    uAddStationEnerygy: 'Jumlah mata tenaga pengecasan semasa anda untuk Bar Pengecasan Tenaga Seluruh BiliBili ialah:',
    consumeStarInRoom: 'Untuk setiap 1 Star yang dihabiskan dalam bilik live ini, anda boleh tambah 1 mata tenaga untuk bilik live ini dan Bar Pengecasan Tenaga Seluruh BiliBili.',

    tabRule: 'Rules',
    ruleDesc: `Habiskan Star/lakukan tugas dalam bar pengecasan tenaga yang sepadan dengan LV untuk mendapatkan mata tenaga
    , selepas bar pengecasan tenaga penuh, anda boleh sertai Cabutan Bertuah Bar Pengecasan Tenaga LV yang sepadan, untuk butiran anugerah tertentu, sila semak "Rekod Anugerah" di penjuru kanan sebelah atas.`,
    prizesBoth: 'Ganjaran yang sepadan untuk bilik live dan Bar Pengecasan Tenaga Seluruh BiliBili:',
    prizeRoom: 'Bar Pengecasan Tenaga Bilik Live',
    prizeStation: 'Bar Pengecasan Tenaga Seluruh BiliBili',
    avatarFrames: 'Bingkai Avatar',
    premium: 'Premium',
    winningRecords: 'Rekod Ganjaran'
  },
  blindBoxAward: {
    title: 'Rekod Ganjaran',
    stars: 'Ganjaran (Star)',
    send: 'Menghadiahkan',
    andWon: 'dan mendapatkan',
    to: 'Kepada',
    noReward: 'Tiada rekod ganjaran',
  }
};

export default ms;
